import { api, unwrap } from '@/core/http';
import type { Category } from '../domain/activity';

export interface ActivityQuery {
  userId?: string;
  category?: Category;
  /** Início do período, ISO. */
  from?: string;
  /** Parte do nome do alvo (aula, produto, evento). */
  q?: string;
  cursor?: string;
  limit?: number;
}

export const auditApi = {
  activity: (q: ActivityQuery) =>
    unwrap(
      api.GET('/v1/audit/activity', {
        params: {
          query: {
            user_id: q.userId,
            category: q.category,
            from: q.from,
            q: q.q || undefined,
            cursor: q.cursor,
            limit: q.limit,
          },
        },
      }),
    ),
  summary: (userId: string) =>
    unwrap(api.GET('/v1/audit/activity/summary', { params: { query: { user_id: userId } } })),
  catalog: () => unwrap(api.GET('/v1/audit/actions')),
};
